import React from 'react';
import Badge from '../shared/Badge';

interface WhyThisSignalPanelProps {
  ruleChain: string;
  labelReason: string;
  changePct: number;
  relVolume: number;
  hasMatchedEvent: boolean;
}

export default function WhyThisSignalPanel({ ruleChain, labelReason, changePct, relVolume, hasMatchedEvent }: WhyThisSignalPanelProps) {
  return (
    <div className="bg-white dark:bg-cat-surface border border-gray-200 dark:border-cat-border rounded-2xl p-6 shadow-sm font-sans overflow-hidden relative">
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-cat-accent to-cat-accent-2" />

      <h3 className="text-gray-900 dark:text-cat-text-main m-0 mb-5 text-[13px] font-bold tracking-tight">
        Why this signal
        <span className="text-gray-500 dark:text-cat-text-muted font-normal text-[12px]"> · Label decision</span>
      </h3>

      <div className="flex flex-col gap-3.5 text-[13px]">
        <div className="flex items-start gap-3">
          <span className="text-gray-500 dark:text-cat-text-muted w-[110px] shrink-0 text-[12px]">Rule chain</span>
          <Badge 
            variant="catalyst-backed" 
            className="normal-case font-normal text-[12px] px-1.5 py-0.5"
          >
            {ruleChain}
          </Badge>
        </div>

        <div className="flex items-start gap-3">
          <span className="text-gray-500 dark:text-cat-text-muted w-[110px] shrink-0 text-[12px]">Actual values</span>
          <span className="text-gray-700 dark:text-[#d5deea] font-mono text-[12px]">
            change_pct = {changePct.toFixed(2)} · rel_volume = {relVolume.toFixed(2)}x {hasMatchedEvent ? '· matched event found' : '· no matched event'}
          </span>
        </div>

        <div className="flex items-start gap-3">
          <span className="text-gray-500 dark:text-cat-text-muted w-[110px] shrink-0 text-[12px]">Label reason</span>
          <span className="text-gray-700 dark:text-[#d5deea]">{labelReason}</span>
        </div>
      </div>
    </div>
  );
}
